var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chart-line q-mb-md"},[_c('LineChartGenerator',{ref:"line",attrs:{"chart-options":_vm.chartOptions,"chart-data":_vm.chartData,"chart-id":"line-chart","dataset-id-key":"label","plugins":_vm.plugins}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }